import { SVGProps, Ref, forwardRef } from 'react';

export const SkillazBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.145.133a.96.96 0 0 1 1.005.02l4.472 2.874a.958.958 0 0 1-.072 1.654l-9.104 4.792a.96.96 0 0 1-.911-.01L7.222 7.067a.958.958 0 0 1-.021-1.663zM9.617 6.205l2.395 1.33 7.191-3.784-2.593-1.667z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.259 11.122a.96.96 0 0 1 .894.02l4.312 2.395a.958.958 0 0 1 0 1.676l-4.312 2.396a.96.96 0 0 1-.894.019l-4.792-2.396a.958.958 0 0 1 0-1.714zm-2.22 3.253 2.625 1.313 2.363-1.313-2.363-1.313z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.392 13.56a.96.96 0 0 1 .932-.042l4.792 2.396c.325.162.53.494.53.857v5.27a.958.958 0 0 1-1.41.846l-4.791-2.556a.96.96 0 0 1-.507-.845v-5.111c0-.332.171-.64.454-.815m1.462 2.366v2.985l2.875 1.533v-3.08z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.201 5.404a.96.96 0 0 1 .952-.013l4.312 2.396c.305.17.493.49.493.838v5.75a.958.958 0 0 1-1.423.838l-4.313-2.396a.96.96 0 0 1-.493-.838V6.23c0-.34.18-.653.472-.825m1.445 2.454v3.557l2.396 1.331V9.19z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6 3.013a.96.96 0 0 1 .462.82v5.203a.96.96 0 0 1-.476.828l-3.996 2.324v4.651a.96.96 0 0 1-.476.829L8.169 22.87a.958.958 0 0 1-1.44-.828v-5.203c0-.343.184-.661.483-.832l3.83-2.188V8.625c0-.356.197-.682.512-.848l9.104-4.792a.96.96 0 0 1 .941.028m-8.642 6.19v5.172a.96.96 0 0 1-.482.832l-3.83 2.188v2.98l7.028-4.087v-4.65c0-.342.181-.658.476-.83l3.996-2.324V5.421z"
            fill="#F7D044"
        />
    </svg>
));
SkillazBrandSize24Glyph.displayName = 'SkillazBrandSize24Glyph';
